import React from "react";

const pageColorMap = {
  school: "#6832c7",
  "submit-school": "#6832c7",
  academic: "#12d7a6",
  "submit-academic": "#12d7a6",
  users: "#ffffff",
};

const LoadingDots = ({ page }) => {
  const dotColor = pageColorMap[page] || "#ffffff";

  return (
    <>
      <style>{`
        .loading-dots-container {
          display: flex;
          justify-content: center;
          align-items: center;
          height: 12rem;
        }

        .dots {
          display: flex;
          gap: 0.5rem;
        }

        .dot {
          width: 1rem;
          height: 1rem;
          background-color: ${dotColor};
          border-radius: 50%;
          animation: bounce 1.4s infinite ease-in-out both;
        }

        .dot1 {
          animation-delay: 0s;
        }

        .dot2 {
          animation-delay: 0.15s;
        }

        .dot3 {
          animation-delay: 0.3s;
        }

        @keyframes bounce {
          0%, 80%, 100% {
            transform: scale(0);
          }
          40% {
            transform: scale(1);
          }
        }
      `}</style>

      <div className="loading-dots-container">
        <div className="dots">
          <span className="dot dot1"></span>
          <span className="dot dot2"></span>
          <span className="dot dot3"></span>
        </div>
      </div>
    </>
  );
};

export default LoadingDots;